'use client';
import { StyledBannerAdsNoSection } from '@/components/common/ygen/sections/banner-ads-no-section/banneradsnosection.style';
import React, { useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Title from '@/components/common/ui/text/Title';
import useContainerOffset from '@/components/hooks/useContainerOffset';
import ReactHtmlParser from 'react-html-parser';

const BannerAdsnoSection = ({ data }) => {
	const offset = useContainerOffset('.container');

	// Memoize the subtitle to prevent unnecessary re-renders
	const subtitle = useMemo(() =>
			data?.subtitle || 'Creating <i>better</i> tomorrows',
		[data?.subtitle]
	);

	// Memoize the description to prevent unnecessary re-renders
	const description = useMemo(() =>
			data?.short_desc ?
				ReactHtmlParser(data.short_desc) :
				'Innovative engineering solutions. Shaping a sustainable tomorrow. Your future, our expertise.',
		[data?.short_desc]
	);

	// Memoize the container style to prevent unnecessary re-renders
	const containerStyle = useMemo(() => ({
		marginLeft: `${offset + 15}px`
	}), [offset]);

	return (
		<StyledBannerAdsNoSection style={containerStyle} className="create-top-rebon">
			<Container fluid>
				<Row>
					<Col md={7}>
						<Title
							tag="h2"
							animClass="fade-up"
							margin="0 0 40px"
							text={subtitle}
							color="#000"
						/>
						<p data-scroll data-scroll-repeat>
							{description}
						</p>
					</Col>
				</Row>
			</Container>
		</StyledBannerAdsNoSection>
	);
};


export default React.memo(BannerAdsnoSection);
